import React from 'react'
// import leftArrow from './images/backArrowIcon.svg'

function Header({navigateToCapture}) {
  return (
    ""
  //   <h1 onClick={navigateToCapture}style={{ fontSize: "18px", padding: "16px 10px",  color: "#3e4e96", marginBottom: "0px", margin: "-20px -20px 0px" ,  cursor: "pointer" }}>
  //   <img width="32" height="auto" src={leftArrow} alt="back" style={{ display: "inline-block"}} /> Signature SDK
  // </h1>
  )
}

export default Header